import Vue from 'vue'

import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'

Vue.use(Toaster, {timeout: 4000})


// WEBPACK FOOTER //
// ./src/plugins/toaster.js